const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnalytics = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 7.0000001,960.36214 c -1.6569,0 -3,1.3431 -3,3 l 0,78.00006 c 0,1.6568 1.3432,3 3,3 l 85.9999999,0 c 1.6569,0 3,-1.3432 3,-3 0,-1.6569 -1.3431,-3 -3,-3 l -83,0 0,-75.00006 c 0,-1.6569 -1.3431998,-3 -2.9999998,-3 z M 67,977.36226 c -1.8106,-0.003 -3.223,1.68217 -3.1562,3.15625 0.082,1.57097 1.5852,2.92584 3.1562,2.84375 l 8.4688,0 -26.5938,25.00004 -9.5625,-7.9688 c -0.6047,-0.71919 -1.5625,-1.12625 -2.5,-1.06249 -0.6687,0.0481 -1.3184,0.32817 -1.8125,0.78129 l -20,17.9999 c -1.2284,1.0302 -1.3817,3.1179 -0.3125,4.3125 1.0693,1.1946 3.153,1.2635 4.3125,0.1563 l 18.0938,-16.2812 9.625,8.0313 c 1.0587,1.227 3.167,1.333 4.3437,0.2187 L 80,987.36226 l 0,9 c -0.022,1.58494 1.4149,3.03125 3,3.03125 1.5851,0 3.0224,-1.44631 3,-3.03125 l 0,-16 c -2e-4,-1.57075 -1.4292,-2.99984 -3,-3 z",
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#ffffff",
      enableBackground: "accumulate"
    },
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnalytics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/analytics.d5b96219adea97ed5a64a3f660815a76.svg";